import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Submits deficiency for one or more documents.
 *
 * @param {object} params
 * @param {number}  params.entityPrimaryId  - entityPrimaryId from entity record
 * @param {string}  params.entityId         - entityId (e.g. "CNT00001")
 * @param {string}  params.emailAddress     - entity email
 * @param {string}  params.spocEmail        - SPOC email
 * @param {Array}   params.deficiencies     - [{ fileName, filePath, descriptions }]
 *
 * Each deficiency item maps to one array entry in the POST body.
 */
export const deficiencyEntityAction = async ({
  entityPrimaryId = 0,
  entityId = "",
  emailAddress = "",
  spocEmail = "",
  deficiencies = [],
}) => {
  try {
    // Build array payload — one entry per deficient document
    const payload = deficiencies.map((d) => ({
      entityPrimayId: entityPrimaryId, // note: API uses "Primay" (typo in spec)
      entityId: entityId,
      // fileName = document label (e.g. "Aadhar Card", "PAN Card") from docName
      fileName: d.docName || d.fileName || "",
      filePath: d.filePath || "",
      descriptions: d.descriptions || d.reason || "",
      emailAddress: emailAddress,
      spoC_Email: spocEmail,
    }));

    console.log("[Deficiency] POST payload:", payload);

    const response = await apiClient.post(
      ATP_API_URL.DEFICIENCY_ENTITY_NEW,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to submit deficiency",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Deficiency submitted successfully",
      };
    }

    return { success: false, message: "Failed to submit deficiency" };
  } catch (error) {
    console.error("[Deficiency] error:", error);
    return {
      success: false,
      message: error.message || "Failed to submit deficiency",
    };
  }
};
